import { createFileRoute } from '@tanstack/react-router'
import { requireSuperAdmin } from '@/lib/auth-guards'
import { CompensationsPage } from '@/features/membership-compensations/compensations-page'

export const Route = createFileRoute(
  '/_authenticated/memberships/compensations'
)({
  beforeLoad: requireSuperAdmin,
  component: CompensationsPage,
})
